<template>
  <div class="flex items-center justify-end gap-4 lg:gap-8">
    <!-- Search only for tablets -->
    <LazyHeaderSearch class="hidden md:block lg:hidden" />
    <button
      v-if="isPdp && isMobile"
      class="-mx-2 p-2 md:hidden"
      :title="$t('search.search')"
      :aria-label="$t('search.search')"
      @click="isMobileSearchBarVisible = !isMobileSearchBarVisible"
    >
      <IconSearch class="size-6 scale-110" />
    </button>
    <HeaderLanguageSwitch />
    <AgsLink
      v-if="!isLoggedIn || user?.status?.isGuestCustomer"
      :to="toLocalePath(routeList.signin.name)"
      size="sm"
      data-qa="profile-icon"
      data-test-id="sign-in-link"
      :aria-label="$t('global.sign_in')"
      @click="trackNavigationHeader($t('global.sign_in'))"
    >
      <template #icon>
        <IconLogin class="size-6" />
      </template>
      <span class="hidden items-center justify-center text-sm lg:flex">
        {{ $t('global.sign_in') }}
      </span>
    </AgsLink>
    <AgsLink
      v-else
      :to="toLocalePath({ name: routeList.account.name })"
      size="sm"
      data-qa="profile-icon"
      data-test-id="my-account-link"
      :aria-label="$t('navigation.my_account')"
      @click="trackNavigationHeader($t('navigation.my_account'))"
    >
      <template #icon>
        <IconLogin class="size-6" />
      </template>
      <span class="hidden items-center justify-center text-sm lg:flex">
        {{ $t('navigation.my_account') }}
      </span>
    </AgsLink>
    <AgsLink
      data-test-id="wishlist-link"
      data-qa="wish-list"
      :to="toLocalePath(routeList.wishlist.name)"
      type="loud"
      :badge="(wishlistCount || 0) > 0 ? wishlistCount : undefined"
      :aria-label="$t('navigation.wishlist')"
      @click="trackNavigationHeader($t('navigation.wishlist'))"
    >
      <template #icon>
        <IconHearth class="size-6" />
      </template>
      <span
        class="hidden items-center justify-center text-sm normal-case lg:flex"
      >
        {{ $t('navigation.wishlist') }}
      </span>
    </AgsLink>
    <BasketPopover
      :items="basketItems"
      :count="countAvailableBasketItems(basketItems)"
      class="mt-1"
    />
  </div>
</template>

<script lang="ts" setup>
const { trackNavigationHeader } = useTrackingEvents()
const { isPdp, isMobileSearchBarVisible } = useUiState()
const { toLocalePath } = useRouteHelpers()
const { isMobile } = useDeviceType()

const [
  { countAvailableBasketItems, data: basketData },
  { user, isLoggedIn },
  { count: wishlistCount },
] = await Promise.all([useAgsBasket(), useAgsUser(), useAgsWishlist()])

const basketItems = computed(() => basketData.value?.items ?? [])
</script>
